/* eslint-disable canonical/filename-match-regex */
import { EMAIL_BASE_ASSET_PATH } from '../constants.js';
export const lottiefilesFramerExpertPartnership = {
    applicationUrl: 'https://contra.com/opportunity/gZRrrXEF-lottie-files-for-framer-expert',
    displayName: 'LottieFiles x Framer',
    emailDetails: {
        alternateExpertPartnerLogoImageUrl: `${EMAIL_BASE_ASSET_PATH}logos/framer.jpg`,
        alternateExpertPartnerName: 'Framer',
        expertPartnerLogoImageUrl: `${EMAIL_BASE_ASSET_PATH}logos/lottiefiles.jpg`,
        heroImageUrl: `${EMAIL_BASE_ASSET_PATH}social-wall.webp`,
    },
    matching: {
        outcomes: [],
        roles: [],
        tools: [],
    },
    name: 'lottiefiles-framer',
    pageDescription: 'Looking for a LottieFiles expert for your next Framer project? Browse and get in touch with LottieFiles freelancers on Contra to find the skills you need.',
    pageTitle: 'Hire LottieFiles Experts for Your Framer Project',
    released: false,
    route: '/lottiefiles-framer',
    userGroup: 'LOTTIEFILES_X_FRAMER_EXPERT',
};
//# sourceMappingURL=lottiefiles-framer.js.map